// extracted by mini-css-extract-plugin
export var icon = "OptionRowAdd-module--icon--6ef71";
export var optionRowAdd = "OptionRowAdd-module--optionRowAdd--1fbfe";